import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./MainAccountView.scss";
import { connect, useDispatch, useSelector } from "react-redux";
import NetworkButtonModal from "./../NetworkButtonModal";
import SetAccountModal from "./SetAccountModal/SetAccountModal";
import { requesteColumns } from "./data";
import Counter from "../../Table/TableComponents/Counter";
import { updateUserRole } from "../actions/actions_updateUserRole";
import { removeUserFromGroup } from "../actions/actions_removeUserFromGroup";
import { NoMembers } from "./HelperComponents";
import ReactTooltip from "react-tooltip";
import { ReactTable } from "../../SimpleForm/ReactTable";
import DeleteNetworkButton from "./DeleteNetworkButton";

 function MainAccountView({ type }) {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.appReducer.userDataReducer.data);
  const [showModal, setShowModal] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const [thisMember, setThisMember] = useState({});
  const [members, setMembers] = useState([]);
  const [editDisabled, setEditDisabled] = useState(true);
  const [requester, setRequester] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSave = () => {
    thisMember.inputValue = inputValue;
    dispatch(updateUserRole({ thisMember }));
    let statusCopy = thisMember;
    statusCopy["Roles"] =
      inputValue === "Owner" ? "Master" : inputValue;
    setThisMember(statusCopy);
  };

  const handleRemove = () => {
    try {
      dispatch(removeUserFromGroup(thisMember));
    } catch (e) {
      console.log(e);
    }
  };

  const openModal = (selMember) => {
    setShowModal(!showModal);
    setThisMember(selMember);
  };

  const onChange = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    if (currentUser) {
      setMembers(currentUser.Group && currentUser.Group.Members ? currentUser.Group.Members : []);
      setRequester(currentUser.Group && currentUser.Group.Invitation ? currentUser.Group.Invitation : []);
      setLoading(false);
    }
  }, [currentUser]);

  const disable = (groupMember) => {
    if (
      groupMember.email === currentUser.email &&
      groupMember.Roles === currentUser.GroupRole
    ) {
      return true;
    } else {
      return false;
    }
  };

    const memberColumns = [
      {
        Header: "Last Name",
        accessor: "last_name",
        Cell: ({ value, row: { index }, column: { id } }) => (
          <>
            <span
              title={value}
              className="cell"
              data-tip
              data-for={`${id}${index}`}
            >
              {value || "--"}
            </span>
            <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
              <span>{value || "--"}</span>
            </ReactTooltip>
          </>
        ),
      },
      {
        Header: "First Name",
        accessor: "first_name",
        Cell: ({ value, row: { index }, column: { id } }) => (
          <>
            <span
              title={value}
              className="cell"
              data-tip
              data-for={`${id}${index}`}
            >
              {value || "--"}
            </span>
            <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
              <span>{value || "--"}</span>
            </ReactTooltip>
          </>
        ),
      },
      {
        Header: "Email Address",
        accessor: "email",
        width: 275,
        Cell: ({ value, row: { index }, column: { id } }) => (
          <>
            <span
              title={value}
              className="cell"
              data-tip
              data-for={`${id}${index}`}
            >
              {value || "--"}
            </span>
            <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
              <span>{value || "--"}</span>
            </ReactTooltip>
          </>
        ),
      },
      {
        Header: "Role(s)",
        accessor: "Roles",
        Cell: ({ value, row: { index }, column: { id } }) => (
          <>
            <span
              title={value}
              className="cell"
              data-tip
              data-for={`${id}${index}`}
            >
              {value || "--"}
            </span>
            <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
              <span>{value || "--"}</span>
            </ReactTooltip>
          </>
        ),
      },
      {
        Header: "Cases Assigned",
        accessor: "casesAssigned",
        id: "casesAssigned",
        show: false,
        Cell: ({ value, row: { index }, column: { id } }) => (
          <>
            <span
              title={value}
              className="cell"
              data-tip
              data-for={`${id}${index}`}
            >
              {value || "--"}
            </span>
            <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
              <span>{value || "--"}</span>
            </ReactTooltip>
          </>
        ),
      },
      {
        Header: "Action",
        fixedWidth: 135,
        disableSortBy: true,
        isButton: true, // removes padding and positioning
        Cell: ({ row: { original } }) => (
          <button
            className="usa-button usa-button--outline editButton"
            disabled={disable(original)}
            style={{ margin: "-12px 0" }}
            onClick={() => {
              openModal(original);
            }}
          >
            Edit
          </button>
        ),
      },
    ];

    return (
      <div>
        <SetAccountModal
          showModal={showModal}
          handleCloseModal={handleCloseModal}
          handleSave={handleSave}
          thisMember={thisMember}
          onChange={onChange}
          inputValue={inputValue}
          handleRemove={handleRemove}
        />
        <div className="header-container">
          <div className="header-content">
            <div className="grid-row">
              <div className="usa-header-profile grid-col-8">
                <h3 className="usa-flag-page-header">My Network</h3>
                <p className="headerInfo">
                  Link yourself to a network where you can share cases and
                  profiles across accounts
                </p>
              </div>
              <div className="button-group">
                <NetworkButtonModal currentUser={currentUser} />
                <DeleteNetworkButton currentUser={currentUser} />
              </div>
            </div>
            <div className="grid-row">
              <div className="navigation">
                <Link
                  className={
                    type === "Members"
                      ? "nav-item active"
                      : "nav-item"
                  }
                  to="/dashboard/myenterprise"
                >
                  Members
                  <button
                    className={
                      type === "Members" ? "badge active" : "badge"
                    }
                  >
                    <div className="badge-number">{members.length}</div>
                  </button>
                </Link>
                <Link
                  className={
                    type === "Requested"
                      ? "nav-item active"
                      : "nav-item"
                  }
                  to="/dashboard/myenterprise/requested"
                >
                  Requested
                  <button
                    className={
                      type === "Requested" ? "badge active" : "badge"
                    }
                  >
                    <div className="badge-number">{requester.length}</div>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="content-container">
          {type === "Members" ? (
            <>
              <Counter
                count={members ? members.length : 0}
                label={"result(s) for Members found"}
              />
              <ReactTable
                data={members}
                columns={memberColumns}
                tableTheme="genericTheme"
                pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                showPagination={members.length > 5}
                noDataComponent={NoMembers}
                loading={loading}
              />
            </>
          ) : (
            <>
              <Counter
                count={requester ? requester.length : 0}
                label={"result(s) for Requester found"}
              />
              <ReactTable
                data={requester}
                columns={requesteColumns}
                tableTheme="genericTheme"
                pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                showPagination={requester.length > 5}
                noDataComponent={NoMembers}
                loading={loading}
              />
            </>
          )}
        </div>
      </div>
    );
  }
export default MainAccountView;
